import React from 'react';

const IconFavouriteSelected = ({ size = 50, ...props }) => {
    return (
        <svg
            width={size}
            viewBox='0 0 50 47.571'
            xmlns='http://www.w3.org/2000/svg'
            {...props}
        >
            <path d='M24.899 39.474L9.514 47.57l3.037-17.207L0 18.22l17.206-2.632L24.9 0l7.895 15.587L50 18.219 37.45 30.364l3.036 17.207z' />
        </svg>
    );
};

export default IconFavouriteSelected;
